<template>
  <v-container fluid style="height: 100%;">
    <List />
    <!--<div style="display: flex;flex-direction:column;height: 100%;">
      <iframe
        class="inspection-iframe"
        :src="`${VUE_APP_V3_HOST}/inspections?hash=${hash}&content-only=true`"
        width="100%"
        height="500"
        allow-same-origin
        frameborder="0"
        style="flex-grow: 1;"
      ></iframe>
    </div>-->
  </v-container>
</template>

<script>
import List from "./components/List";
import { VUE_APP_V3_HOST } from "@/config";

export default {
  components: {
    List,
  },
  data: () => ({
    VUE_APP_V3_HOST,
  }),

  computed: {
    hash() {
      return this.$store.state.auth.accessToken;
    },
  },
};
</script>
<style>
.inspection-iframe {
  height: calc(100vh - 250px);
}
</style>
